import { type LanguageKey } from '@/domain/locale'
import { type AmazonTamConfig } from '@/features/advertisement/constants/tam'

export type AdSizesArray = [number, number][]
export type AdSizesMap = { [key: string]: AdSizesArray }

export type SizeMappings = {
  [key: string]: {
    [key: string]: AdSizesArray
  }
}

export type SizeMappingsGPT = Record<
  string,
  {
    viewPortSize: [number, number]
    sizes: AdSizesArray
  }[]
>

type LazyLoadConfigObject = {
  marginPercent: number
  mobileScaling: number
}

type EnableLazyLoad = boolean | LazyLoadConfigObject

export type GptGlobalProperties = {
  path: string
  enableLazyLoad?: EnableLazyLoad
  usePrebid?: boolean
  aps?: AmazonTamConfig
  useAPS?: boolean
  sizeMappings?: SizeMappingsGPT
}

export type GptTargetingProps = Record<string, string | string[] | undefined | null>

export type GptSlots = {
  id: string
  position?: number
  path?: string
  collapseEmptyDiv?: [boolean, boolean]
  enableLazyLoad?: EnableLazyLoad
  sizeMappingName?: string
  sizes: AdSizesArray
  targeting?: GptTargetingProps
  metaData?: Record<string, unknown>
}

export type AdConfig = GptGlobalProperties & {
  targeting: GptTargetingProps
  slots: GptSlots[]
}

export type GotDynamicConditions = {
  lang: LanguageKey
  mode: 'light' | 'dark'
}

export type GptValue = string | string[] | null | undefined

export type GptTargeting = {
  key: string
  value: GptValue
}

export type FilterName =
  | 'adTypeSection'
  | 'forsaleby'
  | 'make'
  | 'bodytype'
  | 'priceSection'
  | 'year'

export type ForSaleBy = 'delr' | 'ownr'

export const isForSaleBy = (value: string): value is ForSaleBy =>
  value === 'delr' || value === 'ownr'
